import { store } from '../../store';
import call from './';
import callServer from '../call/callServer';
import statusEvent from '@/util/call/kt/ktAPI/statusEvent';
import helpers from '@/util/helpers';
import callChannelType from '@/constants/callChannelType';
import initKt from '@/util/call/kt/initKt';
import initKlcns from '@/util/call/klcns/initKlcns';

const getDefaultState = () => {
  return {
    isStatusSocketConnected: false,
    statusStompClient: null,
    isStatusConnecting: false
  };
};

const state = getDefaultState();
const getters = {
  IS_CALL_STATUS_CONNECTED: (state) => {
    return state.isStatusSocketConnected;
  }
};
const mutations = {
  START_STATUS_CONNECT(state) {
    state.isStatusConnecting = true;
  },
  END_STATUS_CONNECT(state) {
    state.isStatusConnecting = false;
    state.isStatusSocketConnected = true;
  },
  FAIL_STATUS_CONNECT(state) {
    state.isStatusConnecting = false;
    state.isStatusSocketConnected = false;
  },
  OPEN_STATUS(state) {
    statusEvent.connectUser(state);
  },
  CLOSE_STATUS() {
    if (!state.isStatusSocketConnected) return;
    state.isStatusConnecting = false;
    state.isStatusSocketConnected = false;
    if (state.statusStompClient) {
      state.statusStompClient.close();
    }
  },
  sendMessageToStatusSocket(state, payload) {
    if (state.statusStompClient && state.statusStompClient.readyState === WebSocket.OPEN) {
      state.statusStompClient.send(payload);
    }
  }
};
const actions = {
  call_status_connect({ commit, state, rootState, rootGetters }) {
    const { enabledCallAgent, isExistCallAgent } = call.state;

    if (
      !(enabledCallAgent && isExistCallAgent) ||
      state.isStatusSocketConnected ||
      (state.isStatusConnecting && !state.isStatusSocketConnected) ||
      !callServer.state.callWebsocketUrl
    ) {
      return false;
    }
    commit('START_STATUS_CONNECT');

    // url 추가 필요
    const callStatusSocketUrl = callServer.state.callStatusUrl || helpers.findCallStatusUrl();
    if (!callStatusSocketUrl) return;
    state.statusStompClient = new WebSocket(callStatusSocketUrl + '/whiteeye');
    state.statusStompClient.binaryType = 'arraybuffer';

    const { callMode } = rootState.callServer;

    state.statusStompClient.onopen = function (e) {
      if (callMode === callChannelType.KT) {
        initKt.resetCount('status');
      } else if (callMode === callChannelType.KLCNS) {
        initKlcns.resetCount('status');
      }

      commit('END_STATUS_CONNECT');
      commit('OPEN_STATUS');

      // socket 오픈하면 처리할 이벤트 넣기
    };

    state.statusStompClient.onmessage = function (e) {
      let recvData = {};
      try {
        recvData = JSON.parse(e.data);
      } catch (e) {
        return;
      }
      if (recvData.code === -8) {
        // 통계 웹소켓 중복 연결 방지 로직
        if (callMode === callChannelType.KT) {
          initKt.setCount('status', 5);
        } else if (callMode === callChannelType.KLCNS) {
          initKlcns.setCount('status', 5);
        }
      }

      if (recvData.recvType) {
        const { recvType, data } = recvData;

        switch (recvType) {
          case 'ping':
            const { getWorkPlaceId, agentId, getCallBrandList } = store.getters;
            const testMsg = JSON.stringify({
              workPlacesId: getWorkPlaceId,
              agentId: agentId,
              brands: getCallBrandList.map((m) => m.brandId) || [],
              sendType: 'pong'
            });
            commit('sendMessageToStatusSocket', testMsg);
            break;
          case 'agt-status-list':
            commit('changeCallAgentList', data);
            break;
          case 'ready-queue':
            const { enabledCallAgent } = rootGetters;
            if (enabledCallAgent) {
              if (recvType === 'ready-queue') {
                commit('setWaitingCount', Number(data.count));
              }
            }
            break;
          case 'agt-status-tm':
            const statusTm = {};
            const { ready, acw, empty } = data;
            if (ready) statusTm.waitTime = ready;
            if (acw) statusTm.summaryTime = acw;
            if (empty) statusTm.emptyTime = empty;

            commit('setAgentStatistics', statusTm);
            break;
          case 'agt-priv':
            const agentPriv = {
              totalTime: data.callTmSum,
              averageTime: data.callTmAvg,
              myCount: {
                inBound: data.inCallCount,
                outBound: data.outCallCount
              }
            };
            commit('setAgentStatistics', agentPriv);
            break;
          case 'agt-tot':
            try {
              const { getCallBrandList } = store.getters;
              const assignedBrand = data.filter((f) => !!f && getCallBrandList.map((m) => m.brandId).includes(f.brandId));

              let inBound = 0;
              let outBound = 0;

              assignedBrand.forEach((item) => {
                inBound += item.data.totInCalls;
                outBound += item.data.totOutCalls;
              });

              commit('setAgentStatistics', { maxCount: { inBound: inBound, outBound: outBound } });
            } catch (e) {
              commit('setAgentStatistics', { maxCount: { inBound: 0, outBound: 0 } });
              console.error(e);
            }
            break;
          case 'agt-avg':
            commit('setAgentStatistics', { averageCount: { inBound: data.avgInCalls, outBound: data.avgOutCalls } });
            break;
        }
      }
    };

    state.statusStompClient.onclose = function (e) {
      commit('FAIL_STATUS_CONNECT');

      if (callMode === callChannelType.KT) {
        initKt.connectStatusSocket();
      } else if (callMode === callChannelType.KLCNS) {
        initKlcns.connectStatusSocket();
      }
    };
  },
  send_status({ commit, state }, params) {
    const { getWorkPlaceId, getCallBrandList } = store.getters;
    const defaultObj = {
      workPlacesId: getWorkPlaceId,
      brands: getCallBrandList.map((m) => m.brandId) || [],
      sendType: 'status'
    };
    const statusMsg = JSON.stringify(Object.assign(defaultObj, params));
    commit('sendMessageToStatusSocket', statusMsg);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/callWebsocket/status.js